import React, { useContext} from "react";
import BrandedIcon from '../../BrandingWhiteLabel/BrandedIcon';
import { SessionContext } from "../../../context/SessionContext";

const TermsAndConditionsError = ({styles, assetDetails, headerContent}) => {
    const context = useContext(SessionContext);
    const { accountName } = context

    return (
        <div>
            <div className={styles.thanksConfirmation}>
                <BrandedIcon
                    accountName={accountName}
                    iconType={"denied"}
                />
            </div>
            <div className={styles.invMessage}>
                <h1 className="h3 mb-2">We were unable to process your request.</h1>
                <p className="pb-0 mb-0">{`Please contact Customer Support at ${headerContent?.CustomerServicePhone_content}`}</p>
            </div>
        </div>
    )

}

export default TermsAndConditionsError;